import React, { useEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { WIDGET_TRUSTPILOT, WIDGET_TRUSTPILOT_BOOTSTRAP, URL_IMAGES_I } from 'apps/promo/constants/UrlConstants';
import { removeScript } from 'apps/promo/helpers/DOM';
import promoMedia from 'apps/promo/theme/promoMedia';

const TRUSTPILOT_PRELOAD_ROOT_MARGIN = '400px';

const TrustpilotContainer = styled.div`
    ${promoMedia.desktop1440} {
        display: ${(props) => (props.$isMiniWidget ? 'flex' : null)};
        align-items: ${(props) => (props.$isMiniWidget ? 'center' : null)};
        justify-content: ${(props) => (props.$isMiniWidget ? 'center' : null)};
    }
`;
const TrustpilotWidget = styled.div`
    position: relative;
    margin-bottom: ${(props) => (props.$isMiniWidget ? '16px' : '32px')};
    height: ${(props) => (props.$isMiniWidget ? '150px' : '300px')};

    ${promoMedia.tablet744} {
        margin-bottom: ${(props) => (props.$isMiniWidget ? '24px' : '48px')};
    }

    ${promoMedia.desktop1440} {
        margin-bottom: ${(props) => (props.$isMiniWidget ? '32px' : '64px')};
        height: 140px;
    }

    .trustpilot-widget {
        height: 100%;
    }

    iframe {
        border: none;
        overflow: hidden;
    }
`;

const FtLogo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 32px;

    img {
        margin-bottom: 24px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    ${promoMedia.tablet744} {
        margin-bottom: ${(props) => (props.$isMiniWidget ? '32px' : '48px')};
    }

    ${promoMedia.desktop1440} {
        flex-direction: row;
        justify-content: center;
        margin-bottom: ${(props) => (props.$isMiniWidget ? '32px' : '64px')};

        img {
            margin-bottom: 0;
            margin-right: 32px;

            &:last-child {
                margin-right: 0;
            }
        }
    }
`;

const TrustpilotSection = (props) => {
    const widgetRef = useRef(null);
    const [shouldLoad, setShouldLoad] = useState(false);

    useEffect(() => {
        if (!__isBrowser__ || shouldLoad) {
            return undefined;
        }
        if (typeof IntersectionObserver === 'undefined') {
            setShouldLoad(true);
            return undefined;
        }
        const node = widgetRef.current;
        if (!node) {
            return undefined;
        }
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                    setShouldLoad(true);
                    observer.disconnect();
                }
            },
            { rootMargin: TRUSTPILOT_PRELOAD_ROOT_MARGIN },
        );
        observer.observe(node);
        return () => observer.disconnect();
    }, [shouldLoad]);

    useEffect(() => {
        if (!__isBrowser__ || !shouldLoad) {
            return undefined;
        }
        const script = document.createElement('script');
        script.src = WIDGET_TRUSTPILOT_BOOTSTRAP;
        script.defer = true;
        document.body.appendChild(script);
        return () => removeScript(WIDGET_TRUSTPILOT_BOOTSTRAP);
    }, [shouldLoad]);

    return (
        <TrustpilotContainer $isMiniWidget={props.isMiniWidget}>
            <TrustpilotWidget ref={widgetRef} $isMiniWidget={props.isMiniWidget}>
                {shouldLoad && (
                    <div
                        data-schema-type="Organization"
                        data-stars="5"
                        data-theme="light"
                        data-style-width="100%"
                        data-style-height="100%"
                        data-businessunit-id="59295ddd0000ff0005a34b26"
                        data-template-id={props.isMiniWidget ? '53aa8807dec7e10d38f59f32' : '53aa8912dec7e10d38f59f36'}
                        data-tags={props.lang === 'ru' ? 'en' : props.lang}
                        data-locale={props.lang === 'ru' ? 'en' : props.lang}
                        className="trustpilot-widget"
                    >
                        <iframe title="Customer reviews powered by Trustpilot" loading="lazy" src={WIDGET_TRUSTPILOT} />
                    </div>
                )}
            </TrustpilotWidget>
            <FtLogo $isMiniWidget={props.isMiniWidget}>
                <img src={`${URL_IMAGES_I}/ft-logo.svg`} alt="FT logo" width="274" height="72" />
                <img src={`${URL_IMAGES_I}/ft-logo-2024.svg`} alt="FT logo 2024" width="274" height="72" />
            </FtLogo>
        </TrustpilotContainer>
    );
};

TrustpilotSection.propTypes = {
    lang: PropTypes.string.isRequired,
    isMiniWidget: PropTypes.bool,
};
export default TrustpilotSection;
